import { render, staticRenderFns } from "./myCourses.vue?vue&type=template&id=e383ca7a&scoped=true&"
import script from "./myCourses.vue?vue&type=script&lang=js&"
export * from "./myCourses.vue?vue&type=script&lang=js&"
import style0 from "./myCourses.vue?vue&type=style&index=0&id=e383ca7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e383ca7a",
  null
  
)

export default component.exports